import Slider from "react-slick";
import homeFrame7 from "../../assets/Home Frame 0.png";
import homeFrame1 from "../../assets/Home Frame 1.png";
// import homeFrame2 from "../../assets/Home Frame 2.png";
import homeFrame3 from "../../assets/Home Frame 3.png";
// import homeFrame4 from "../../assets/Home Frame 4.png";
import homeFrame5 from "../../assets/Home Frame 5.png";
import homeFrame6 from "../../assets/Home Frame 6.png";
import homeFrame0 from "../../assets/Home Frame 7.jpg";

const Slideshow = () => {
  const images = [
    homeFrame0,
    homeFrame1,
    // homeFrame2,
    homeFrame3,
    // homeFrame4,
    homeFrame5,
    homeFrame6,
    homeFrame7,
  ];

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Slider {...settings}>
      {images.map((image, index) => (
        <div key={index}>
          <img
            src={image}
            alt={`Slide ${index}`}
            style={{
              height: "200px",
              width: "100%",
            }}
          />
        </div>
      ))}
    </Slider>
  );
};

export default Slideshow;
